<div class="relative inline-block w-full">
  <button type="button" (click)="toggleDropdown()" [attr.aria-expanded]="isOpen" aria-haspopup="true" [ngClass]="{
          'bg-white shadow': backgroundStyle == 'white',
          'bg-primary shadow-lg': backgroundStyle == 'primary',
          'bg-transparent border-white': backgroundStyle == 'outline-primary',
          'text-white': textStyle == 'white',
          'text-black': textStyle == 'black' || textStyle == 'primary',
           }" class="flex justify-between items-center w-full px-3 py-3 text-base text-black rounded-xl relative">
    <span class="pr-2">{{ (selectedValue ? selectedValue.label : placeholder) | translate }}</span>
    <vw-down-icon aria-hidden="true" class="transform transition-transform" [ngClass]="{ 'rotate-180': isOpen }"></vw-down-icon>
  </button>

  <div [ngClass]="{
          'bg-white shadow': backgroundStyle == 'white',
          'bg-primary shadow-lg': backgroundStyle == 'primary',
          'text-white': textStyle == 'white' && !onColorMenu,
          'text-black': (textStyle == 'black' || textStyle == 'primary') && !onColorMenu,
          'left-auto px-3 py-3 rounded-xl': !onColorMenu,
          'right-0 py-1 rounded-card bg-vw-surface shadow-float text-vw-ink': onColorMenu,
          'opacity-100 pointer-events-auto visible translate-y-0': isOpen,
          'opacity-0 pointer-events-none invisible -translate-y-2': !isOpen
           }"
    class="absolute mt-1 min-w-max w-full invisible text-black outline-none z-[9999999] transition-all duration-300">
    <!-- Sur fond vert (sélecteur de langue de Bienvenue, P0.2.1) : un menu blanc
         ancré à droite (il ne sort plus de l'écran), lignes de 44 px, la langue
         choisie cochée. -->
    <ul class="overflow-y-auto">
      @for (option of options; track option; let i = $index) {
      <li>
        <button type="button" (click)="selectOption(option)" [attr.aria-current]="onColorMenu && isSelected(option) ? 'true' : null"
          [ngClass]="onColorMenu ? 'flex min-h-target items-center justify-between gap-4 px-4 text-body' : 'block px-4 py-2'"
          class="w-full text-left whitespace-nowrap">
          {{ option.label | translate }}
          @if (onColorMenu && isSelected(option)) {
            <vw-check-icon class="block h-5 w-5 text-vw-primary" aria-hidden="true" />
          }
        </button>
      </li>
      }
    </ul>
  </div>
</div>